export default {
  clear_search_history: "Clear search history",
  input_placeholder: "Search or Filter {entityName}...",
  input_placeholder_manager: "Quicksearch...",
}
